module.exports = __webpack_public_path__ + "img/video.bfdf15d.svg";